var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{attrs:{"id":_vm.id,"name":_vm.name,"type":_vm.type,"showBackButton":_vm.showBackButton},on:{"backButtonPressed":_vm.clickBack},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('MapIcon',{attrs:{"label":"","color":"red","size":39}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }